// @flow

import type {MarkdocRenderTag} from '@stripe-internal/markdoc/types';

export const isMarkdocAstTag = (tag: MarkdocRenderTag | string) => {
  if (typeof tag === 'object') {
    return tag.astType === 'Tag';
  }
  return false;
};
